import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteConfirmDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('common.delete.title')}</DialogTitle>
      <DialogContent>
        <Typography>{t('common.delete.message')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t('common.delete.cancel')}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
          autoFocus
        >
          {t('common.delete.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog; 